<faxe-page-layout showClock=true>
  <faxe-map class = "negative-margin"
            [pins]="pins"
  ></faxe-map>
</faxe-page-layout>
